module.exports = __webpack_public_path__ + "static/media/screen-double.2993d0c6.png";